import { createSlice } from "@reduxjs/toolkit";
import { fileUploadAPI } from "../../services/fileUpload";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const fileUploadSlice = createSlice({
  name: "fileUploadData",
  initialState: data,
  reducers: {
    fileUploadInfo(state) {
      state.isLoading = true;
    },
    fileUploadInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    fileUploadInfoFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    fileUploadInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const fileUploadHandler = (data) => async (dispatch) => {
  try {
    dispatch(fileUploadAction.fileUploadInfo());
    const response = await fileUploadAPI(data);
    dispatch(fileUploadAction.fileUploadInfoSuccess(response));
  } catch (e) {
    dispatch(fileUploadAction.fileUploadInfoFailure(e?.response?.data?.message));
  }
};
export default fileUploadSlice.reducer;
export const fileUploadAction = fileUploadSlice.actions;
